import { darkGrey } from '~/colors'

export default {
    container: {
        height: 90,
        marginBottom: 25
    },
    map: {
        border: '3px solid #E9EAEC',
        marginRight: 8
    },
    title: {
        lineHeight: 2,
        marginTop: 8,
        textTransform: 'uppercase',
        color: darkGrey,
        fontWeight: '700'
    },
    text: {
        lineHeight: 2
    }
}



// WEBPACK FOOTER //
// ./src/components/Location/styles.js